/** Нормализует телефон к виду 79991234567 (только цифры, код 7). Согласовано с бэкендом и `frontend/admin` `normalizePhone`. */
export function normalizePhone(raw: string): string {
  const digits = raw.replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('8') && digits.length >= 11) return `7${digits.slice(1)}`;
  if (!digits.startsWith('7')) return `7${digits}`;
  return digits;
}

/**
 * Отображение сохранённого номера (11 цифр с 7): +7 (999) 123-45-67 — как в CRM-админке (`formatPhone`).
 */
export function formatPhoneRuDisplay(raw: string | null | undefined): string {
  if (raw == null || !String(raw).trim()) return '';
  const digits = normalizePhone(String(raw));
  if (digits.length !== 11) return String(raw).trim();
  return `+7 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9)}`;
}

/** Ввод телефона → +7 (999) 123-45-67 (как `formatPhone` в CRM-админке). */
export function sanitizePhoneInput(raw: string): string {
  const plusRequested = raw.trim().startsWith('+');
  let digits = raw.replace(/\D/g, '');

  if (!digits) return plusRequested ? '+7' : '';
  if (digits.startsWith('8')) digits = `7${digits.slice(1)}`;
  else if (!digits.startsWith('7')) digits = `7${digits}`;

  digits = digits.slice(0, 11);
  const local = digits.slice(1);

  let out = '+7';
  if (local.length === 0) return out;
  out += ' (';
  out += local.slice(0, Math.min(3, local.length));
  if (local.length >= 3) out += ')';
  if (local.length > 3) {
    out += ' ';
    out += local.slice(3, Math.min(6, local.length));
  }
  if (local.length > 6) {
    out += '-';
    out += local.slice(6, Math.min(8, local.length));
  }
  if (local.length > 8) {
    out += '-';
    out += local.slice(8, Math.min(10, local.length));
  }
  return out;
}

const RU_ZONE_PHONE_PLAUSIBLE = /^7[34789]\d{9}$/;

export type ValidateResult = true | string;

export function validateEmail(value: string, opts?: { required?: boolean }): ValidateResult {
  const v = (value ?? '').trim().toLowerCase();
  if (!v) return opts?.required ? 'Укажите email.' : true;
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'Некорректный формат email.';
  return true;
}

/** Российский мобильный после нормализации — 11 цифр, начинается с 7. */
export function validatePhoneRu(value: string, opts: { required: boolean }): ValidateResult {
  const raw = (value ?? '').trim();
  const digitsOnly = raw.replace(/\D/g, '');
  if (!digitsOnly || digitsOnly === '7' || digitsOnly === '8') {
    return opts.required ? 'Укажите номер телефона полностью (российский мобильный, +7).' : true;
  }
  let n = normalizePhone(raw);
  if (n.length > 11) n = n.slice(0, 11);
  if (n.length !== 11 || !n.startsWith('7')) {
    return 'Телефон: укажите полный российский номер (11 цифр, код страны 7).';
  }
  if (!RU_ZONE_PHONE_PLAUSIBLE.test(n)) {
    return 'Укажите корректный номер телефона в формате +7.';
  }
  return true;
}
